import styled from 'styled-components';
import {dFlexCenter, mobileMedia, tabletMedia} from '../../../../globalVariables/GlobalVariables';

export const rightGroup = styled.div`
    ${dFlexCenter}
    gap: 8px;
    ${tabletMedia} {
        gap: 0;
    }
`;

export const dateBtnWrap = styled.div`
    position: relative;
    order: -1;
    ${mobileMedia} {
        order: 0;
    }
`;
